window.slate = window.slate || {};
window.theme = window.theme || {};
// somewhere to store custom global functions
window.rfd = window.rfd || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {

      var variantImage = variant.featured_image || {};

      /* RFD Modification to handle situations where the "currentVariant" doesnt exist */
      if (this.currentVariant !== null) {
        var currentVariantImage = this.currentVariant.featured_image;
      } else {
        var currentVariantImage = {};
      }

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {

      /* RFD Modification to handle situations where the "currentVariant" doesnt exist */
      if (this.currentVariant !== null) {
        var currentVariant = this.currentVariant;
      } else {
        var currentVariant = {};
      }

      if (variant.price === currentVariant.price && variant.compare_at_price === currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Polyfills ================*/
if (!window.HTMLPictureElement) {
     !function(a,b,c){"use strict";function d(a){return a.trim?a.trim():a.replace(/^\s+|\s+$/g,"")}function e(){var b;R=!1,U=a.devicePixelRatio,S={},T={},b=(U||1)*D.xQuant,D.uT||(D.maxX=Math.max(1.3,D.maxX),b=Math.min(b,D.maxX),v.DPR=b),V.width=Math.max(a.innerWidth||0,B.clientWidth),V.height=Math.max(a.innerHeight||0,B.clientHeight),V.vw=V.width/100,V.vh=V.height/100,V.em=v.getEmValue(),V.rem=V.em,o=D.lazyFactor/2,o=o*b+o,q=.4+.1*b,l=.5+.2*b,m=.5+.25*b,p=b+1.3,(n=V.width>V.height)||(o*=.9),I&&(o*=.9),u=[V.width,V.height,b].join("-")}function f(a,b,c){var d=b*Math.pow(a-.4,1.9);return n||(d/=1.3),a+=d,a>c}function g(a){var b,c=v.getSet(a),d=!1;"pending"!=c&&(d=u,c&&(b=v.setRes(c),d=v.applySetCandidate(b,a))),a[v.ns].evaled=d}function h(a,b){return a.res-b.res}function i(a,b,c){var d;return!c&&b&&(c=a[v.ns].sets,c=c&&c[c.length-1]),d=j(b,c),d&&(b=v.makeUrl(b),a[v.ns].curSrc=b,a[v.ns].curCan=d,d.res||_(d,d.set.sizes)),d}function j(a,b){var c,d,e;if(a&&b)for(e=v.parseSet(b),a=v.makeUrl(a),c=0;c<e.length;c++)if(a==v.makeUrl(e[c].url)){d=e[c];break}return d}function k(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[v.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}var l,m,n,o,p,q,r,s,t,u,v={},w=function(){},x=b.createElement("img"),y=x.getAttribute,z=x.setAttribute,A=x.removeAttribute,B=b.documentElement,C={},D={xQuant:1,lazyFactor:.4,maxX:2},E="data-pfsrc",F=E+"set",G="webkitBackfaceVisibility"in B.style,H=navigator.userAgent,I=/rident/.test(H)||/ecko/.test(H)&&H.match(/rv\:(\d+)/)&&RegExp.$1>35,J="currentSrc",K=/\s+\+?\d+(e\d+)?w/,L=/((?:\([^)]+\)(?:\s*and\s*|\s*or\s*|\s*not\s*)?)+)?\s*(.+)/,M=/^([\+eE\d\.]+)(w|x)$/,N=/\s*\d+h\s*/,O=a.respimgCFG,P=("https:"==location.protocol,"position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"),Q="font-size:100%!important;",R=!0,S={},T={},U=a.devicePixelRatio,V={px:1,"in":96},W=b.createElement("a"),X=!1,Y=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},Z=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},$=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=Z(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")});return function(b,d){var e;if(!(b in S))if(S[b]=!1,d&&(e=b.match(a)))S[b]=e[1]*V[e[2]];else try{S[b]=new Function("e",c(b))(V)}catch(f){}return S[b]}}(),_=function(a,b){return a.w?(a.cWidth=v.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.x,a},ab=function(c){var d,e,f,g=c||{};if(g.elements&&1==g.elements.nodeType&&("IMG"==g.elements.nodeName.toUpperCase()?g.elements=[g.elements]:(g.context=g.elements,g.elements=null)),g.reparse&&(g.reevaluate=!0,a.console&&console.warn&&console.warn("reparse was renamed to reevaluate!")),d=g.elements||v.qsa(g.context||b,g.reevaluate||g.reselect?v.sel:v.selShort),f=d.length){for(v.setupRun(g),X=!0,e=0;f>e;e++)v.fillImg(d[e],g);v.teardownRun(g)}},bb=Z(function(a){var b=[1,"x"],c=d(a||"");return c&&(c=c.replace(N,""),b=c.match(M)?[1*RegExp.$1,RegExp.$2]:!1),b});if(J in x||(J="src"),C["image/jpeg"]=!0,C["image/gif"]=!0,C["image/png"]=!0,C["image/svg+xml"]=b.implementation.hasFeature("http://wwwindow.w3.org/TR/SVG11/feature#Image","1.1"),v.ns=("ri"+(new Date).getTime()).substr(0,9),v.supSrcset="srcset"in x,v.supSizes="sizes"in x,v.supPicture=!!a.HTMLPictureElement,v.supSrcset&&v.supPicture&&!v.supSizes&&!function(a){x.srcset="data:,a",a.src="data:,a",v.supSrcset=x.complete===a.complete,v.supPicture=v.supSrcset&&v.supPicture}(b.createElement("img")),v.selShort="picture>img,img[srcset]",v.sel=v.selShort,v.cfg=D,v.supSrcset&&(v.sel+=",img["+F+"]"),v.DPR=U||1,v.u=V,v.types=C,s=v.supSrcset&&!v.supSizes,v.setSize=w,v.makeUrl=Z(function(a){return W.href=a,W.href}),v.qsa=function(a,b){return a.querySelectorAll(b)},v.matchesMedia=function(){return v.matchesMedia=a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?function(a){return!a||matchMedia(a).matches}:v.mMQ,v.matchesMedia.apply(this,arguments)},v.mMQ=function(a){return a?$(a):!0},v.calcLength=function(a){var b=$(a,!0)||!1;return 0>b&&(b=!1),b},v.supportsType=function(a){return a?C[a]:!0},v.parseSize=Z(function(a){var b=(a||"").match(L);return{media:b&&b[1],length:b&&b[2]}}),v.parseSet=function(a){if(!a.cands){var b,c,d,e,f,g,h=a.srcset;for(a.cands=[];h;)h=h.replace(/^\s+/g,""),b=h.search(/\s/g),d=null,-1!=b?(c=h.slice(0,b),e=c.charAt(c.length-1),","!=e&&c||(c=c.replace(/,+$/,""),d=""),h=h.slice(b+1),null==d&&(f=h.indexOf(","),-1!=f?(d=h.slice(0,f),h=h.slice(f+1)):(d=h,h=""))):(c=h,h=""),c&&(d=bb(d))&&(g={url:c.replace(/^,+/,""),set:a},g[d[1]]=d[0],"x"==d[1]&&1==d[0]&&(a.has1x=!0),a.cands.push(g))}return a.cands},v.getEmValue=function(){var a;if(!r&&(a=b.body)){var c=b.createElement("div"),d=B.style.cssText,e=a.style.cssText;c.style.cssText=P,B.style.cssText=Q,a.style.cssText=Q,a.appendChild(c),r=c.offsetWidth,a.removeChild(c),r=parseFloat(r,10),B.style.cssText=d,a.style.cssText=e}return r||16},v.calcListLength=function(a){if(!(a in T)||D.uT){var b,c,e,f,g,h,i=d(a).split(/\s*,\s*/),j=!1;for(g=0,h=i.length;h>g&&(b=i[g],c=v.parseSize(b),e=c.length,f=c.media,!e||!v.matchesMedia(f)||(j=v.calcLength(e))===!1);g++);T[a]=j?j:V.width}return T[a]},v.setRes=function(a){var b;if(a){b=v.parseSet(a);for(var c=0,d=b.length;d>c;c++)_(b[c],a.sizes)}return b},v.setRes.res=_,v.applySetCandidate=function(a,b){if(a.length){var c,d,e,g,j,k,n,r,s,t,w,x,y,z=b[v.ns],A=u,B=o,C=q;if(r=z.curSrc||b[J],s=z.curCan||i(b,r,a[0].set),d=v.DPR,y=s&&s.res,!n&&r&&(x=I&&!b.complete&&s&&y-.2>d,x||s&&!(p>y)||(s&&d>y&&y>l&&(m>y&&(B*=.8,C+=.04*d),s.res+=B*Math.pow(y-C,2)),t=!z.pic||s&&s.set==a[0].set,s&&t&&s.res>=d&&(n=s))),!n)for(y&&(s.res=s.res-(s.res-y)/2),a.sort(h),k=a.length,n=a[k-1],e=0;k>e;e++)if(c=a[e],c.res>=d){g=e-1,n=a[g]&&(j=c.res-d)&&(x||r!=v.makeUrl(c.url))&&f(a[g].res,j,d)?a[g]:c;break}return y&&(s.res=y),n&&(w=v.makeUrl(n.url),z.curSrc=w,z.curCan=n,w!=r&&v.setSrc(b,n),v.setSize(b)),A}},v.setSrc=function(a,b){var c;a.src=b.url,G&&(c=a.style.zoom,a.style.zoom="0.999",a.style.zoom=c)},v.getSet=function(a){var b,c,d,e=!1,f=a[v.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&v.matchesMedia(c.media)&&(d=v.supportsType(c.type))){"pending"==d&&(c=d),e=c;break}return e},v.parseSets=function(a,b,d){var e,f,g,h,i="PICTURE"==b.nodeName.toUpperCase(),l=a[v.ns];(l.src===c||d.src)&&(l.src=y.call(a,"src"),l.src?z.call(a,E,l.src):A.call(a,E)),(l.srcset===c||!v.supSrcset||a.srcset||d.srcset)&&(e=y.call(a,"srcset"),l.srcset=e,h=!0),l.sets=[],i&&(l.pic=!0,k(b,l.sets)),l.srcset?(f={srcset:l.srcset,sizes:y.call(a,"sizes")},l.sets.push(f),g=(s||l.src)&&K.test(l.srcset||""),g||!l.src||j(l.src,f)||f.has1x||(f.srcset+=", "+l.src,f.cands.push({url:l.src,x:1,set:f}))):l.src&&l.sets.push({srcset:l.src,sizes:null}),l.curCan=null,l.curSrc=c,l.supported=!(i||f&&!v.supSrcset||g),h&&v.supSrcset&&!l.supported&&(e?(z.call(a,F,e),a.srcset=""):A.call(a,F)),l.supported&&!l.srcset&&(!l.src&&a.src||a.src!=v.makeUrl(l.src))&&(null==l.src?a.removeAttribute("src"):a.src=l.src),l.parsed=!0},v.fillImg=function(a,b){var c,d,e=b.reselect||b.reevaluate;if(a[v.ns]||(a[v.ns]={}),d=a[v.ns],e||d.evaled!=u){if(!d.parsed||b.reevaluate){if(c=a.parentNode,!c)return;v.parseSets(a,c,b)}d.supported?d.evaled=u:g(a)}},v.setupRun=function(b){(!X||R||U!=a.devicePixelRatio)&&(e(),b.elements||b.context||clearTimeout(t))},v.supPicture?(ab=w,v.fillImg=w):(b.createElement("picture"),function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";h=setTimeout(e,"loading"==a?200:999),b.body&&(c=c||d.test(a),v.fillImgs(),c&&clearTimeout(h))},f=function(){v.fillImgs()},g=function(){clearTimeout(t),R=!0,t=setTimeout(f,99)},h=setTimeout(e,b.body?0:20);Y(a,"resize",g),Y(b,"readystatechange",e)}()),v.respimage=ab,v.fillImgs=ab,v.teardownRun=w,ab._=v,a.respimage=a.picturefill||ab,!a.picturefill)for(a.respimgCFG={ri:v,push:function(a){var b=a.shift();"function"==typeof v[b]?v[b].apply(v,a):(D[b]=a[0],X&&v.fillImgs({reselect:!0}))}};O&&O.length;)a.respimgCFG.push(O.shift());a.picturefill||(a.picturefill=a.respimage,a.picturefillCFG||(a.picturefillCFG=a.respimgCFG))}(window,document);
    
    "document"in window.self&&("classList"in document.createElement("_")&&(!document.createElementNS||"classList"in document.createElementNS("http://www.w3.org/2000/svg","g"))||function(t){"use strict";if("Element"in t){var e=t.Element.prototype,n=Object,i=String.prototype.trim||function(){return this.replace(/^\s+|\s+$/g,"")},s=Array.prototype.indexOf||function(t){for(var e=0,n=this.length;e<n;e++)if(e in this&&this[e]===t)return e;return-1},r=function(t,e){this.name=t,this.code=DOMException[t],this.message=e},o=function(t,e){if(""===e)throw new r("SYNTAX_ERR","An invalid or illegal string was specified");if(/\s/.test(e))throw new r("INVALID_CHARACTER_ERR","String contains an invalid character");return s.call(t,e)},c=function(t){for(var e=i.call(t.getAttribute("class")||""),n=e?e.split(/\s+/):[],s=0,r=n.length;s<r;s++)this.push(n[s]);this._updateClassName=function(){t.setAttribute("class",this.toString())}},a=c.prototype=[],l=function(){return new c(this)};if(r.prototype=Error.prototype,a.item=function(t){return this[t]||null},a.contains=function(t){return-1!==o(this,t+="")},a.add=function(){var t,e=arguments,n=0,i=e.length,s=!1;do{t=e[n]+"",-1===o(this,t)&&(this.push(t),s=!0)}while(++n<i);s&&this._updateClassName()},a.remove=function(){var t,e,n=arguments,i=0,s=n.length,r=!1;do{for(t=n[i]+"",e=o(this,t);-1!==e;)this.splice(e,1),r=!0,e=o(this,t)}while(++i<s);r&&this._updateClassName()},a.toggle=function(t,e){t+="";var n=this.contains(t),i=n?!0!==e&&"remove":!1!==e&&"add";return i&&this[i](t),!0===e||!1===e?e:!n},a.toString=function(){return this.join(" ")},n.defineProperty){var u={get:l,enumerable:!0,configurable:!0};try{n.defineProperty(e,"classList",u)}catch(t){void 0!==t.number&&-2146823252!==t.number||(u.enumerable=!1,n.defineProperty(e,"classList",u))}}else n.prototype.__defineGetter__&&e.__defineGetter__("classList",l)}}(window.self),function(){"use strict";var t=document.createElement("_");if(t.classList.add("c1","c2"),!t.classList.contains("c2")){var e=function(t){var e=DOMTokenList.prototype[t];DOMTokenList.prototype[t]=function(t){var n,i=arguments.length;for(n=0;n<i;n++)t=arguments[n],e.call(this,t)}};e("add"),e("remove")}if(t.classList.toggle("c3",!1),t.classList.contains("c3")){var n=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return 1 in arguments&&!this.contains(t)==!e?e:n.call(this,t)}}t=null}());
    
}

if (!window.Promise) {
    !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.WHATWGFetch={})}(this,function(t){"use strict";var e={searchParams:"URLSearchParams"in self,iterable:"Symbol"in self&&"iterator"in Symbol,blob:"FileReader"in self&&"Blob"in self&&function(){try{return new Blob,!0}catch(t){return!1}}(),formData:"FormData"in self,arrayBuffer:"ArrayBuffer"in self};if(e.arrayBuffer)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],o=ArrayBuffer.isView||function(t){return t&&r.indexOf(Object.prototype.toString.call(t))>-1};function n(t){if("string"!=typeof t&&(t=String(t)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t))throw new TypeError("Invalid character in header field name");return t.toLowerCase()}function i(t){return"string"!=typeof t&&(t=String(t)),t}function s(t){var r={next:function(){var e=t.shift();return{done:void 0===e,value:e}}};return e.iterable&&(r[Symbol.iterator]=function(){return r}),r}function a(t){this.map={},t instanceof a?t.forEach(function(t,e){this.append(e,t)},this):Array.isArray(t)?t.forEach(function(t){this.append(t[0],t[1])},this):t&&Object.getOwnPropertyNames(t).forEach(function(e){this.append(e,t[e])},this)}function h(t){if(t.bodyUsed)return Promise.reject(new TypeError("Already read"));t.bodyUsed=!0}function f(t){return new Promise(function(e,r){t.onload=function(){e(t.result)},t.onerror=function(){r(t.error)}})}function u(t){var e=new FileReader,r=f(e);return e.readAsArrayBuffer(t),r}function d(t){if(t.slice)return t.slice(0);var e=new Uint8Array(t.byteLength);return e.set(new Uint8Array(t)),e.buffer}function c(){return this.bodyUsed=!1,this._initBody=function(t){var r;this._bodyInit=t,t?"string"==typeof t?this._bodyText=t:e.blob&&Blob.prototype.isPrototypeOf(t)?this._bodyBlob=t:e.formData&&FormData.prototype.isPrototypeOf(t)?this._bodyFormData=t:e.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)?this._bodyText=t.toString():e.arrayBuffer&&e.blob&&((r=t)&&DataView.prototype.isPrototypeOf(r))?(this._bodyArrayBuffer=d(t.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):e.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(t)||o(t))?this._bodyArrayBuffer=d(t):this._bodyText=t=Object.prototype.toString.call(t):this._bodyText="",this.headers.get("content-type")||("string"==typeof t?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):e.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},e.blob&&(this.blob=function(){var t=h(this);if(t)return t;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?h(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(u)}),this.text=function(){var t,e,r,o=h(this);if(o)return o;if(this._bodyBlob)return t=this._bodyBlob,e=new FileReader,r=f(e),e.readAsText(t),r;if(this._bodyArrayBuffer)return Promise.resolve(function(t){for(var e=new Uint8Array(t),r=new Array(e.length),o=0;o<e.length;o++)r[o]=String.fromCharCode(e[o]);return r.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},e.formData&&(this.formData=function(){return this.text().then(p)}),this.json=function(){return this.text().then(JSON.parse)},this}a.prototype.append=function(t,e){t=n(t),e=i(e);var r=this.map[t];this.map[t]=r?r+", "+e:e},a.prototype.delete=function(t){delete this.map[n(t)]},a.prototype.get=function(t){return t=n(t),this.has(t)?this.map[t]:null},a.prototype.has=function(t){return this.map.hasOwnProperty(n(t))},a.prototype.set=function(t,e){this.map[n(t)]=i(e)},a.prototype.forEach=function(t,e){for(var r in this.map)this.map.hasOwnProperty(r)&&t.call(e,this.map[r],r,this)},a.prototype.keys=function(){var t=[];return this.forEach(function(e,r){t.push(r)}),s(t)},a.prototype.values=function(){var t=[];return this.forEach(function(e){t.push(e)}),s(t)},a.prototype.entries=function(){var t=[];return this.forEach(function(e,r){t.push([r,e])}),s(t)},e.iterable&&(a.prototype[Symbol.iterator]=a.prototype.entries);var l=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function y(t,e){var r,o,n=(e=e||{}).body;if(t instanceof y){if(t.bodyUsed)throw new TypeError("Already read");this.url=t.url,this.credentials=t.credentials,e.headers||(this.headers=new a(t.headers)),this.method=t.method,this.mode=t.mode,this.signal=t.signal,n||null==t._bodyInit||(n=t._bodyInit,t.bodyUsed=!0)}else this.url=String(t);if(this.credentials=e.credentials||this.credentials||"same-origin",!e.headers&&this.headers||(this.headers=new a(e.headers)),this.method=(r=e.method||this.method||"GET",o=r.toUpperCase(),l.indexOf(o)>-1?o:r),this.mode=e.mode||this.mode||null,this.signal=e.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&n)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(n)}function p(t){var e=new FormData;return t.trim().split("&").forEach(function(t){if(t){var r=t.split("="),o=r.shift().replace(/\+/g," "),n=r.join("=").replace(/\+/g," ");e.append(decodeURIComponent(o),decodeURIComponent(n))}}),e}function b(t,e){e||(e={}),this.type="default",this.status=void 0===e.status?200:e.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in e?e.statusText:"OK",this.headers=new a(e.headers),this.url=e.url||"",this._initBody(t)}y.prototype.clone=function(){return new y(this,{body:this._bodyInit})},c.call(y.prototype),c.call(b.prototype),b.prototype.clone=function(){return new b(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new a(this.headers),url:this.url})},b.error=function(){var t=new b(null,{status:0,statusText:""});return t.type="error",t};var m=[301,302,303,307,308];b.redirect=function(t,e){if(-1===m.indexOf(e))throw new RangeError("Invalid status code");return new b(null,{status:e,headers:{location:t}})},t.DOMException=self.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(t,e){this.message=t,this.name=e;var r=Error(t);this.stack=r.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function w(r,o){return new Promise(function(n,i){var s=new y(r,o);if(s.signal&&s.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var h=new XMLHttpRequest;function f(){h.abort()}h.onload=function(){var t,e,r={status:h.status,statusText:h.statusText,headers:(t=h.getAllResponseHeaders()||"",e=new a,t.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach(function(t){var r=t.split(":"),o=r.shift().trim();if(o){var n=r.join(":").trim();e.append(o,n)}}),e)};r.url="responseURL"in h?h.responseURL:r.headers.get("X-Request-URL");var o="response"in h?h.response:h.responseText;n(new b(o,r))},h.onerror=function(){i(new TypeError("Network request failed"))},h.ontimeout=function(){i(new TypeError("Network request failed"))},h.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},h.open(s.method,s.url,!0),"include"===s.credentials?h.withCredentials=!0:"omit"===s.credentials&&(h.withCredentials=!1),"responseType"in h&&e.blob&&(h.responseType="blob"),s.headers.forEach(function(t,e){h.setRequestHeader(e,t)}),s.signal&&(s.signal.addEventListener("abort",f),h.onreadystatechange=function(){4===h.readyState&&s.signal.removeEventListener("abort",f)}),h.send(void 0===s._bodyInit?null:s._bodyInit)})}w.polyfill=!0,self.fetch||(self.fetch=w,self.Headers=a,self.Request=y,self.Response=b),t.Headers=a,t.Request=y,t.Response=b,t.fetch=w,Object.defineProperty(t,"__esModule",{value:!0})});
    
}

if (!window.fetch) {
    !function(e,n){"object"==typeof exports&&"undefined"!=typeof module?n():"function"==typeof define&&define.amd?define(n):n()}(0,function(){"use strict";function e(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})}function n(e){return!(!e||"undefined"==typeof e.length)}function t(){}function o(e){if(!(this instanceof o))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],c(e,this)}function r(e,n){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,o._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null!==t){var o;try{o=t(e._value)}catch(r){return void f(n.promise,r)}i(n.promise,o)}else(1===e._state?i:f)(n.promise,e._value)})):e._deferreds.push(n)}function i(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if(n instanceof o)return e._state=3,e._value=n,void u(e);if("function"==typeof t)return void c(function(e,n){return function(){e.apply(n,arguments)}}(t,n),e)}e._state=1,e._value=n,u(e)}catch(r){f(e,r)}}function f(e,n){e._state=2,e._value=n,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var n=0,t=e._deferreds.length;t>n;n++)r(e,e._deferreds[n]);e._deferreds=null}function c(e,n){var t=!1;try{e(function(e){t||(t=!0,i(n,e))},function(e){t||(t=!0,f(n,e))})}catch(o){if(t)return;t=!0,f(n,o)}}var a=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,n){var o=new this.constructor(t);return r(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(e,n,o)),o},o.prototype["finally"]=e,o.all=function(e){return new o(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(n){r(e,n)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(n){n(e)})},o.reject=function(e){return new o(function(n,t){t(e)})},o.race=function(e){return new o(function(t,r){if(!n(e))return r(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)o.resolve(e[i]).then(t,r)})},o._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},o._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var l=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"Promise"in l?l.Promise.prototype["finally"]||(l.Promise.prototype["finally"]=e):l.Promise=o});
}

!function(){"use strict";function o(){var o=window,t=document;if(!("scrollBehavior"in t.documentElement.style&&!0!==o.__forceSmoothScrollPolyfill__)){var l,e=o.HTMLElement||o.Element,r=468,i={scroll:o.scroll||o.scrollTo,scrollBy:o.scrollBy,elementScroll:e.prototype.scroll||n,scrollIntoView:e.prototype.scrollIntoView},s=o.performance&&o.performance.now?o.performance.now.bind(o.performance):Date.now,c=(l=o.navigator.userAgent,new RegExp(["MSIE ","Trident/","Edge/"].join("|")).test(l)?1:0);o.scroll=o.scrollTo=function(){console.log('Running'); void 0!==arguments[0]&&(!0!==f(arguments[0])?h.call(o,t.body,void 0!==arguments[0].left?~~arguments[0].left:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:o.scrollY||o.pageYOffset):i.scroll.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:o.scrollY||o.pageYOffset))},o.scrollBy=function(){void 0!==arguments[0]&&(f(arguments[0])?i.scrollBy.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):h.call(o,t.body,~~arguments[0].left+(o.scrollX||o.pageXOffset),~~arguments[0].top+(o.scrollY||o.pageYOffset)))},e.prototype.scroll=e.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==f(arguments[0])){var o=arguments[0].left,t=arguments[0].top;h.call(this,this,void 0===o?this.scrollLeft:~~o,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value could not be converted");i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},e.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==f(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},e.prototype.scrollIntoView=function(){if(!0!==f(arguments[0])){var l=function(o){for(;o!==t.body&&!1===(e=p(l=o,"Y")&&a(l,"Y"),r=p(l,"X")&&a(l,"X"),e||r);)o=o.parentNode||o.host;var l,e,r;return o}(this),e=l.getBoundingClientRect(),r=this.getBoundingClientRect();l!==t.body?(h.call(this,l,l.scrollLeft+r.left-e.left,l.scrollTop+r.top-e.top),"fixed"!==o.getComputedStyle(l).position&&o.scrollBy({left:e.left,top:e.top,behavior:"smooth"})):o.scrollBy({left:r.left,top:r.top,behavior:"smooth"})}else i.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}function n(o,t){this.scrollLeft=o,this.scrollTop=t}function f(o){if(null===o||"object"!=typeof o||void 0===o.behavior||"auto"===o.behavior||"instant"===o.behavior)return!0;if("object"==typeof o&&"smooth"===o.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+o.behavior+" is not a valid value for enumeration ScrollBehavior.")}function p(o,t){return"Y"===t?o.clientHeight+c<o.scrollHeight:"X"===t?o.clientWidth+c<o.scrollWidth:void 0}function a(t,l){var e=o.getComputedStyle(t,null)["overflow"+l];return"auto"===e||"scroll"===e}function d(t){var l,e,i,c,n=(s()-t.startTime)/r;c=n=n>1?1:n,l=.5*(1-Math.cos(Math.PI*c)),e=t.startX+(t.x-t.startX)*l,i=t.startY+(t.y-t.startY)*l,t.method.call(t.scrollable,e,i),e===t.x&&i===t.y||o.requestAnimationFrame(d.bind(o,t))}function h(l,e,r){var c,f,p,a,h=s();l===t.body?(c=o,f=o.scrollX||o.pageXOffset,p=o.scrollY||o.pageYOffset,a=i.scroll):(c=l,f=l.scrollLeft,p=l.scrollTop,a=n),d({scrollable:c,method:a,startTime:h,startX:f,startY:p,x:e,y:r})}}"object"==typeof exports&&"undefined"!=typeof module?module.exports={polyfill:o}:o()}();

/* Disable minification (remove `.min` from URL path) for more info */

(function(undefined) {}).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {
    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productQuantity: '[data-product-qty]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };
    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);
        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on(
            'variantPriceChange' + this.namespace,
            this.updateProductPrices.bind(this)
        );

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
            this.$container.on(
                'variantImageChange' + this.namespace,
                this.updateProductImage.bind(this)
            );
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {
        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            var variant = evt.variant;
            var selectorAddToCart = selectors.addToCart;
            var selectorAddToCartText = selectors.addToCartText;
            var themeStrings = theme.strings;
            $(selectors.priceWrapper, this.$container).removeClass('hide');
            if (variant) {
                if ($(selectorAddToCart, this.$container).attr('data-taken') !== 'true') {
                    // If variant is available change button to 'add to cart'
                    if (variant.available) {
                        $(selectorAddToCart, this.$container)
                            .prop('disabled', false)
                            .attr('id', '')
                            .attr('data-variant-id', '')
                            .attr('type', 'submit');
                        $(selectorAddToCartText, this.$container).html(themeStrings.addToCart);

                        if (
                            variant.inventory_management === 'shopify' &&
                            variant.inventory_policy !== 'continue'
                        ) {
                            $(selectors.productQuantity, this.$container).attr(
                                'max',
                                variant.inventory_quantity
                            );
                        }
                    } else {
                        // if variant is not available, check for Back in Stock, otherwise show default 'Sold Out' label
                        if (
                            theme.disabled_modules.back_in_stock === 'true' ||
                            theme.disabled_modules.back_in_stock === true
                        ) {
                            $(selectorAddToCart, this.$container)
                                .prop('disabled', true)
                                .attr('id', '')
                                .attr('data-variant-id', '');
                            $(selectorAddToCartText, this.$container).html(themeStrings.soldOut);
                        } else {
                            $(selectorAddToCart, this.$container)
                                .attr('type', 'button')
                                .prop('disabled', false)
                                .attr('id', 'BIS_trigger')
                                .attr('data-variant-id', variant.id);
                            $(selectorAddToCartText, this.$container).html(
                                themeStrings.back_in_stock
                            );
                        }
                    }
                }
            } else {
                if ($(selectorAddToCart, this.$container).attr('data-taken') !== 'true') {
                    var validSelection = true;
                    var selectorCount = $(selectors.singleOptionSelector).length;
                    // Loop over single option selectors and check for empty value
                    $(selectors.singleOptionSelector).each(function() {
                        if ($(this).val() === '') {
                            validSelection = false;
                        }
                    });
                    // If all options have been selected, then it must be an invalid combination.
                    if (validSelection) {
                        $(selectorAddToCartText, this.$container).html(themeStrings.unavailable);
                        $(selectorAddToCart, this.$container)
                            .prop('disabled', true)
                            .attr('id', '')
                            .attr('data-variant-id', '');
                    } else {
                        // Disable the button to prevent any accidental submissions
                        $(selectorAddToCart, this.$container).prop('disabled', true);
                        // Check option count to determine the best label to use
                        if (selectorCount > 1) {
                            $(selectorAddToCartText, this.$container).html(
                                themeStrings.select_options
                            );
                        } else {
                            if (
                                this.productSingleObject.type === 'Gift Card' ||
                                this.productSingleObject.type === 'giftcard'
                            ) {
                                $(selectorAddToCartText, this.$container).html(
                                    themeStrings.select_value
                                );
                            } else {
                                $(selectorAddToCartText, this.$container).html(
                                    themeStrings.select_single
                                );
                            }
                        }
                    }
                }
            }
        },
        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
            var alteredMoneyFormat = theme.moneyFormat;
            alteredMoneyFormat = alteredMoneyFormat.replace(
                'amount_with_comma_separator',
                'amount'
            );
            alteredMoneyFormat = alteredMoneyFormat.replace(
                'amount_with_apostrophe_separator',
                'amount'
            );
            $(selectors.productPrice, this.$container).html(
                slate.Currency.formatMoney(variant.price, alteredMoneyFormat)
            );

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    slate.Currency.formatMoney(variant.compare_at_price, alteredMoneyFormat)
                );
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },
        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(
                variant.featured_image.src,
                this.settings.imageSize
            );
            this.$featuredImage.attr('src', sizedImgUrl);
        },
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });
    return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {
                parameters: { _method: 'delete' }
            });
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();

/* Product Countdown Functions */
$(document).ready(function() {
    if ($('[data-countdown]').length) {
        var now = moment().unix();

        $('[data-countdown]').each(function() {
            var launchDT = moment.tz($(this).data('countdown'), 'UTC');

            if (launchDT.unix() > now) {
                $(this)
                    .countdown(launchDT.toDate())
                    .on('update.countdown', function(event) {
                        $(this)
                            .find('.info_days')
                            .html(event.strftime('%-D') + ' ' + $(this).data('days-label'));
                        $(this)
                            .find('.info_hours')
                            .html(event.strftime('%H') + ' :');
                        $(this)
                            .find('.info_mins')
                            .html(event.strftime('%M') + ' :');
                        $(this)
                            .find('.info_seconds')
                            .html(event.strftime('%S'));
                    })
                    .on('finish.countdown', function(event) {
                        location.reload();
                    });
            }
        });
    }
});
/* End Product Countdown Functions */

$(document).ready(function() {
    if ($('.gdpr-block').length) {
        const token = getParameterByName('token');
        if (token) {
            // Show choice form
            gdprApiCall('request/confirm', '{"token":"' + token + '"}');
        } else {
            // Show email form
            $('.gdpr-loader').addClass('visually-hidden');
            $('.gdpr-request').removeClass('visually-hidden');
            $('.gdpr-complete').addClass('visually-hidden');
        }

        // Confirm email button
        $(document).on('click', 'input[data-gdpr-confirm]', function(e) {
            e.preventDefault();

            $('.gdpr-error').remove();
            $('#gdpr_email').removeClass('gdpr-error-field');

            const email = $('#gdpr_email').val();
            const referrer = $('#gdpr_referrer').val();
            const storecode = window.theme.gsCode;

            if (ValidateEmail(email)) {
                gdprApiCall('request', '{"email":"' + email + '", "referrer":"' + referrer + '", "store":"' + storecode +'"}');
            } else {
                $('#gdpr_email')
                    .addClass('gdpr-error-field')
                    .after('<div class="gdpr-error">' + gdprMessages.invalid_email + '</div>');
            }
        });

        // Data request / delete
        $(document).on('click', 'input[data-gdpr-choice]', function(e) {
            const choice = $(this).data('gdpr-choice');
            gdprApiCall(
                'complete',
                '{"token":"' + gdprSettings.token + '", "choice":"' + choice + '"}'
            );
        });
    }
});

function gdprApiCall(method, payload) {
    $('.gdpr-loader').removeClass('visually-hidden');
    $('.gdpr-complete, .gdpr-request').addClass('visually-hidden');
    $.ajax({
        type: 'POST',
        url: gdprSettings.apiUrl + method,
        data: payload,
        beforeSend: function(xhr) {
            xhr.setRequestHeader('X-Shopify-Shop-Domain', gdprSettings.shopDomain);
        },
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        error: function(error) {
            var response = error.responseJSON || {};
            $('.gdpr-loader').addClass('visually-hidden');
            $('.gdpr-complete, .gdpr-request').addClass('visually-hidden');
            handleResponseError(response);

        },
        success: function(data) {
            $('.gdpr-loader').addClass('visually-hidden');

            if (data.success) {
                handleResponseSuccess(data.method);
            } else {
                $('.gdpr-complete, .gdpr-request').addClass('visually-hidden');
                handleResponseError(data);
            }
        }
    });

    function handleResponseSuccess(dataMethod) {
        switch (dataMethod) {
            case 'initiate':
                $('.gdpr-complete, .gdpr-request').addClass('visually-hidden');
                $('.gdpr-response p').html(gdprSettings.messages.success_initiate);
                $('.gdpr-response').removeClass('visually-hidden');
                break;
            case 'confirm':
                $('.gdpr-complete').removeClass('visually-hidden');
                $('.gdpr-request').addClass('visually-hidden');
                gdprSettings.token = data.token;
                break;
            case 'confirmed':
                $('.gdpr-complete, .gdpr-request').addClass('visually-hidden');
                $('.gdpr-response p').html(gdprSettings.messages.success_complete);
                $('.gdpr-response').removeClass('visually-hidden');
                break;
            default:
                break;
        }
    }

    function handleResponseError(data) {
        switch (data.error) {
            case 'no_token':
                $('.gdpr-response p').html(gdprSettings.messages.no_token);
                break;
            case 'no_choice':
                $('.gdpr-response p').html(gdprSettings.messages.no_choice);
                break;
            case 'invalid_token':
                $('.gdpr-response p').html(gdprSettings.messages.invalid_token);
                break;
            case 'invalid_email':
                $('.gdpr-response p').html(gdprSettings.messages.invalid_email);
                break;
            case 'invalid_request':
                if(data.detail) {
                    switch(data.detail) {
                        case 'Invalid Token':
                            $('.gdpr-response p').html(gdprSettings.messages.invalid_token);
                            break;
                        case 'invalid email':
                            $('.gdpr-response p').html(gdprSettings.messages.invalid_email);
                            break;
                    }
                }
                else {
                    $('.gdpr-response p').html(gdprSettings.messages.internal);
                }
                break;
            case 'already_requested':
                $('.gdpr-response p').html(gdprSettings.messages.already_requested);
                break;
            default:
                $('.gdpr-response p').html(gdprSettings.messages.internal);
                break;
        }

        $('.gdpr-response').removeClass('visually-hidden');
    }
}

$(document).ready(function() {
    if ($('.klarna-page').length) {
        $('#js-benefit-container-mobile').slick({
            dots: true,
            prevArrow: false,
            nextArrow: false
        });
        $('#js-how-to-container-mobile').slick({
            dots: true,
            prevArrow: false,
            nextArrow: false
        });
        $('.js-toggle').click(function(e) {
            e.preventDefault();

            var $this = $(this);
            var parent = $this.parent().parent();

            if ($this.next().hasClass('current')) {
                $this.next().removeClass('current');
                $this.removeClass('selected');
                $this.next().slideUp(350);
            } else {
                parent.find('li .inner').removeClass('current');
                parent.find('.toggle').removeClass('selected');
                parent.find('li .inner').slideUp(350);
                $this.next().toggleClass('current');
                $this.toggleClass('selected');
                $this.next().slideToggle(350, function() {
                    if ($('.selected').offset()) {
                        var itemPos = $('.selected').offset().top - 100;
                    }
                });
            }
        });
    }
});


/*================ Modules ================*/
/**
 * Module for AJAX pagination.
 *
 */

(function() {
    'use strict';

    var selectors = {
        ajaxPagLinks: '[data-ajax-pag-link]',
        ajaxPagContent: '[data-ajax-pag-content]',
        btnTxt: '[data-btn-text]'
    };

    var $targetBtns = null;
    var $targetPagBtns = null;

    function disableBtns(loadStr, $btns) {
        var loadStr = loadStr;

        $targetBtns = $btns;
        $targetBtns.attr('disabled', 'disabled');

        $targetBtns.each(function(i, el) {
            var $txt = $(el).find(selectors.btnTxt);
            $txt.data('orig-text', $txt.text());
            $txt.text(loadStr);
        });
    }

    function enableBtns() {
        $targetBtns.each(function(i, el) {
            var $txt = $(el).find(selectors.btnTxt);
            $txt.text($txt.data('orig-text'));
        });
        $targetBtns.removeAttr('disabled');
    }

    window.rfd.disableBtns = disableBtns;
    window.rfd.enableBtns = enableBtns;

    var pagIsAjaxed = false;

    function _init() {
        if (!pagIsAjaxed) {
            $('body').on('click', selectors.ajaxPagLinks, function(e) {
                e.preventDefault();

                var $btn = $(this);

                if (window.rfd && window.rfd.disableBtns) {
                    window.rfd.disableBtns(window.theme.strings.loading, $btn);
                }

                var jqxhr = $.get($btn.attr('href'), function(data) {
                    var newContentHtml = $(data)
                        .find(selectors.ajaxPagContent)
                        .html();
                    var $newLink = $(data).find(selectors.ajaxPagLinks);

                    if ($newLink.length) {
                        $(selectors.ajaxPagLinks).replaceWith($newLink);
                    } else {
                        $(selectors.ajaxPagLinks).remove();
                    }

                    $(selectors.ajaxPagContent).append(newContentHtml);

                    if (window.rfd && window.rfd.enableBtns) {
                        window.rfd.enableBtns();
                    }
                }).done(function() {
                    addCarousel();
                });
            });
        }
    }

    _init();
})();

$(document).on('click', '.js-cancel-order', function(e) {
    e.preventDefault();

    var $this = $(this);
    var params = $this.context.dataset;

    $('.spinner').addClass('loading');

    $.ajax({
        url: params.url,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        method: 'POST',
        data: JSON.stringify({
            token: params.hmac,
            store: params.store,
            order: {
                id: parseInt(params.orderid),
                ref: params.ordername,
                timestamp: parseInt(params.time)
            }
        }),
        success: function(data) {
            $message = $('<div>', {
                text: OCASettings.locales.success
            });
            $this.replaceWith($message);
            $('.spinner').removeClass('loading');
            $('.js-cancel-timer').addClass('visually-hidden');
        },
        error: function(xhr, status, error) {
            $message = $('<div>', {
                text: OCASettings.locales.error
            });
            $('.spinner').removeClass('loading');
            $this.replaceWith($message);
            $('.js-cancel-timer').addClass('visually-hidden');
        }
    });
});

$(document).on('click', '.quickBuySizeInput.disabled', function(e) {
    e.stopPropagation();
    e.preventDefault();
});

$(document).ready(function() {
    if ($('.generic-promotional-page').length) {
        $('.results__items').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        //***********
        // QUICK BUY
        //***********

        $(document).on('click', '[data-add-to-cart]', function() {
            var $this = $(this);
            var $gsPopupContainerBis = $('#gs-popup__container__bis');
            if ($this.hasClass('bis__active')) {
                if ($('.backInStockDetails').css('display') === 'block') {
                    if ($gsPopupContainerBis.length > 0) {
                        $gsPopupContainerBis.hide();
                    } else {
                        $('.backInStockDetails').hide();
                    }
                } else {
                    var variantID = $('[data-product-select]').val();
                    $('#bis__variant')
                        .val(variantID)
                        .trigger('change');
                    $('.bis__form').show();
                    $('.bis__response').hide();
                    // Show BIS popup
                    if ($gsPopupContainerBis.length > 0) {
                        $gsPopupContainerBis.show();
                    }
                }

                var $selectASizeText = $('.selectASizeText');

                if ($this.hasClass('disabledBtn')) {
                    $selectASizeText.text('{{ "products.product.select_a_size" | t }}');
                    $selectASizeText.show();
                }
                return false;
            } else if ($this.hasClass('disabledBtn')) {
                $selectASizeText.text('{{ "products.product.select_a_size" | t }}');
                $selectASizeText.show();
                return false;
            }
        });

        $(document).on('mouseover', '.product-card', function() {
            $(this)
                .find('.quick-buy-container')
                .show();
        });
        $(document).on('mouseout', '.product-card', function() {
            $(this)
                .find('.quick-buy-container')
                .hide();
        });

        $('.quickBuyProductImage').hover(
            function() {
                var productHoveredURL = $(this).data('url');
                var $rowSelector = $('.quick-buy-container[data-url="' + productHoveredURL + '"]');
                $rowSelector.stop().animate({ opacity: 1.0 });
            },
            function() {
                var productHoveredURL = $(this).data('url');
                var $rowSelector = $('.quick-buy-container[data-url="' + productHoveredURL + '"]');
                $rowSelector.stop().animate({ opacity: 0.0 });
            }
        );

        $('.quick-buy-container').hover(
            function() {
                $(this)
                    .stop()
                    .animate({ opacity: 1.0 });
            },
            function() {
                $(this)
                    .stop()
                    .animate({ opacity: 0.0 });
            }
        );
    }
});

/*================ Legacy Page ================*/

$(document).ready(function() {
    if ($('.legacy-page').length) {
        /***********************
         ***** SLICK SLIDER *****
         ************************/

        $('.results__items').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        /*********************************
         ***** SCROLL TO NEXT SECTION *****
         **********************************/

        $('a[href*=\\#]:not([href=\\#])').on('click', function(e) {
            e.preventDefault();
            $('html, body').animate(
                { scrollTop: $($(this).attr('href')).offset().top },
                500,
                'linear'
            );
        });

        /********************
         ***** QUICK BUY *****
         *********************/
        // TODO This is all duplicate code - this needs cleaning up throughout the codebase as part of the major refactor

        $(document).on('click', '[data-add-to-cart]', function() {
            var $selectedSizeText = $('.selectASizeText');

            var $this = $(this);

            if ($this.hasClass('bis__active')) {
                var $backInStockDetails = $('.backInStockDetails');
                var $popUpContainer = $('#gs-popup__container__bis');

                if ($backInStockDetails.css('display') === 'block') {
                    if ($popUpContainer.length > 0) {
                        $popUpContainer.hide();
                    } else {
                        $backInStockDetails.hide();
                    }
                } else {
                    var variantID = $('[data-product-select]').val();
                    $('#bis__variant')
                        .val(variantID)
                        .trigger('change');

                    $('.bis__form').show();
                    $('.bis__response').hide();

                    // Show BIS popup
                    if ($popUpContainer.length > 0) {
                        $popUpContainer.show();
                    }
                }
                if ($this.hasClass('disabledBtn')) {
                    $selectedSizeText.text('{{ "products.product.select_a_size" | t }}').show();
                }

                return false;
            } else if ($this.hasClass('disabledBtn')) {
                $selectedSizeText.text('{{ "products.product.select_a_size" | t }}').show();

                return false;
            }
        });

        $(document).on('mouseover', '.product-card', function() {
            $(this)
                .find('.quick-buy-container')
                .show();
        });

        $(document).on('mouseout', '.product-card', function() {
            $(this)
                .find('.quick-buy-container')
                .hide();
        });

        $('.quickBuyProductImage').hover(
            function() {
                var productHoveredURL = $(this).data('url');
                var $rowSelector = $('.quick-buy-container[data-url="' + productHoveredURL + '"]');

                $rowSelector.stop().animate({ opacity: 1.0 });
            },
            function() {
                var productHoveredURL = $(this).data('url');
                var $rowSelector = $('.quick-buy-container[data-url="' + productHoveredURL + '"]');

                $rowSelector.stop().animate({ opacity: 0.0 });
            }
        );

        $('.quick-buy-container').hover(
            function() {
                $(this)
                    .stop()
                    .animate({ opacity: 1.0 });
            },
            function() {
                $(this)
                    .stop()
                    .animate({ opacity: 0.0 });
            }
        );

        /*****************************************
         ***** RESET SCROLL TO TOP ON REFRESH *****
         ******************************************/

        $(window).on('beforeunload', function() {
            $(window).scrollTop(10);
        });
    }
});

/*================ End Of Legacy Page ================*/

$(document).ready(function() {
    if ($('.lifting-club-form-page').length) {
        $(window).scrollTop(0);
        $(document).on('click', '.lifting-club-submit-btn', function(e) {
            e.preventDefault();
            var liftingClubUrl = e.currentTarget.dataset.url;
            if (validateSignup()) {
                var data = $(this)
                    .closest('form')
                    .serializeFormJSON();
                $.ajax({
                    type: 'POST',
                    url: liftingClubUrl,
                    data: JSON.stringify(data),
                    cache: false,
                    dataType: 'json',
                    contentType: 'application/json;',
                    error: function(error) {
                        onErrorfullSending();
                    },
                    success: function(data) {
                        onSuccessfullSending();
                        onSuccessfullSendingMain();
                    }
                });
            }
        });

        $(document).on('click', '.lifting-club-submit-opt-out-btn', function(e) {
            e.preventDefault();
            if (validateOptOut()) {
                var data = $(this)
                    .closest('form')
                    .serializeFormJSON();
                var encodedEmail = window.btoa(data.email);
                var liftingClubUrl = e.currentTarget.dataset.url;
                data.optin = false;
                data = JSON.stringify(data);
                $.ajax({
                    type: 'PUT',
                    url: liftingClubUrl + '/' + encodedEmail,
                    data: data,
                    cache: false,
                    dataType: 'json',
                    contentType: 'application/json;',
                    error: function(error) {
                        onErrorfullSending();
                    },
                    success: function(data) {
                        onSuccessfullSending();
                    }
                });
            }
        });

        function validateSignup() {
            var valid = true;
            $('.lifting-club-signup .lifting-club--field-error').removeClass(
                'lifting-club--field-error'
            );
            $('.lifting-club-signup .lifting-club-form__error-text').css('display', 'none');
            var $fname = $('#lifting-club-first-name');
            var $fnameError = $('#lifting-club-first-name-error');
            var $lname = $('#lifting-club-last-name');
            var $lnameError = $('#lifting-club-last-name-error');
            var $ename = $('#lifting-club-customer-email');
            var $enameError = $('#lifting-club-email-error');
            var $mname = $('#lifting-club-mobile-block');
            var $mnameError = $('#lifting-club-mobile-error');
            var $tname = $('#lifting-club-terms');
            var $tnameText = $('#lifting-club-terms-text');

            if (!validateEmail($ename.val())) {
                valid = false;
                $ename.addClass('lifting-club--field-error');
                $enameError.css('display', 'block');
            }
            if ($fname.val() === '' || $fname.val() === undefined) {
                valid = false;
                $fname.addClass('lifting-club--field-error');
                $fnameError.css('display', 'block');
            }
            if ($lname.val() === '' || $lname.val() === undefined) {
                valid = false;
                $lname.addClass('lifting-club--field-error');
                $lnameError.css('display', 'block');
            }
            if ($mname.val() === '' || $mname.val() === null) {
                valid = false;
                $mname.addClass('lifting-club--field-error');
                $mnameError.css('display', 'block');
            }
            if (!$tname[0].checked) {
                valid = false;
                $tnameText.addClass('lifting-club--field-error');
            }

            return valid;
        }

        function validateOptOut() {
            var valid = true;
            $('.lifting-club-signup .lifting-club--field-error').removeClass(
                'lifting-club--field-error'
            );
            $('.lifting-club-signup .lifting-club-form__error-text').css('display', 'none');
            var $ename = $('#lifting-club-customer-email');
            var $enameError = $('#lifting-club-email-error');

            if (!validateEmail($ename.val())) {
                valid = false;
                $ename.addClass('lifting-club--field-error');
                $enameError.css('display', 'block');
            }

            return valid;
        }

        function validateEmail(email) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                return true;
            }

            return false;
        }

        function onSuccessfullSending() {
            $('.lifting-club-signup .lifting-club-form__error-text').css('display', 'none');
            $('.lifting-club-form__container').hide();
            $('.lifting-club-form__text-container').hide();
            $('.lifting-club-form__success').show();
            $(window).scrollTop(0);
        }

        function onSuccessfullSendingMain() {
            $('#page-content').addClass('lifting-club-form__full-height');
            $('.lifting-club-form__header').css('display', 'none');
        }

        function onErrorfullSending() {
            $('#lifting-club-server-error').css('display', 'block');
        }

        (function($) {
            $.fn.serializeFormJSON = function() {
                var o = {};
                var a = this.serializeArray();
                $.each(a, function() {
                    if (o[this.name]) {
                        if (!o[this.name].push) {
                            o[this.name] = [o[this.name]];
                        }
                        o[this.name].push(this.value || '');
                    } else {
                        o[this.name] = this.value || '';
                    }
                });

                return o;
            };
        })(jQuery);
    }
});

$(document).ready(function() {
    if ($('.german-landing-page').length) {
        (function() {
            var items = document.querySelectorAll('.timeline li');

            function isElementInViewport(el) {
                var rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <=
                        (window.innerHeight || document.documentElement.clientHeight) * 1.4 &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            function callbackFunc() {
                for (var i = 0; i < items.length; i++) {
                    if (isElementInViewport(items[i])) {
                        items[i].classList.add('in-view');
                    }
                }
            }

            // listen for events
            window.addEventListener('load', callbackFunc);
            window.addEventListener('resize', callbackFunc);
            window.addEventListener('scroll', callbackFunc);

            window.mobilecheck = function() {
                var check = false;
                (function(a) {
                    if (
                        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                            a
                        ) ||
                        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                            a.substr(0, 4)
                        )
                    )
                        check = true;
                })(navigator.userAgent || navigator.vendor || window.opera);
                return check;
            };
        })();

        var mainVideo = $('#campaign-video');
        var isMobile = window.mobilecheck();

        var videoDirectory = !isMobile ? 'desktop' : 'mobile';

        mainVideo.attr(
            'poster',
            'https://cdn.gymshark.com/video/campaign/' +
                videoDirectory +
                '/de-brand-consideration-poster.png'
        );
        mainVideo.append(
            '<source src="https://cdn.gymshark.com/video/campaign/' +
                videoDirectory +
                '/de-brand-consideration-campaign.webm" type="video/webm; codecs=vp8,vorbis">'
        );
        mainVideo.append(
            '<source src="https://cdn.gymshark.com/video/campaign/' +
                videoDirectory +
                '/de-brand-consideration-campaign.mp4" type="video/mp4; codecs=avc1.42E01E,mp4a.40.2">'
        );

        $(window).load(function() {
            $(window).on('beforeunload', function() {
                $(window).scrollTop(0);
            });

            $(document).on('click', '.german-landing-page-submit-button', function(e) {
                e.preventDefault();
                var email = $('#german-landing-page-email').val();
                if (validateSignup()) {
                    $('#mc_hidden_email').val(email);
                    $('.footer__newsletter-popup, .newsletter-popup-overlay').removeClass(
                        'visually-hidden'
                    );
                    $('.footer__newsletter-popup').addClass(
                        'german-landing-page__footer-newsletter-popup'
                    );
                    $('.footer__newsletter-popup-arrow').hide();
                }
            });

            $(document).on('click', '#mc-embedded-subscribe', function(e) {
                e.preventDefault();
                $('.footer__newsletter-popup-arrow').show();
                $('.footer__newsletter-popup').removeClass(
                    'german-landing-page__footer-newsletter-popup'
                );
            });

            function validateSignup() {
                var valid = true;
                $('.german-landing-page__signup .german-landing-page--field-error').removeClass(
                    'german-landing-page--field-error'
                );
                $('.german-landing-page__signup .german-landing-page__form-error-text').css(
                    'display',
                    'none'
                );
                var $ename = $('#german-landing-page-email');
                var $enameError = $('#german-landing-page-email-error');

                if (!validateEmail($ename.val())) {
                    valid = false;
                    $ename.addClass('german-landing-page--field-error');
                    $enameError.css('display', 'block');
                }

                return valid;
            }

            function onSuccessfullSending() {
                $('.german-landing-page__signup .german-landing-page__form-error-text').css(
                    'display',
                    'none'
                );
                $('.german-landing-page__form-container').hide();
                $('.german-landing-page__success').show();
            }

            function onErrorfullSending() {
                $('#german-landing-page-server-error').css('display', 'block');
            }

            function validateEmail(email) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                    return true;
                }

                return false;
            }
        });
    }
});

window.mobileChecker = function () {
    var deviceObject = {};
    deviceObject.mobileCheck = false;
    deviceObject.gsDevice = null;

    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) deviceObject.mobileCheck = true;

        deviceObject.gsDevice = a.toString();
    })(navigator.userAgent || navigator.vendor || window.opera);

    return deviceObject;
};

/*================ Content-v1 template ================*/

$(document).ready(function() {
    if ($('.content-v1__page').length) {
        $('.toggle').click(function(e) {
            e.preventDefault();

            var $this = $(this);
            var $currentParentParent = $this.parent().parent();

            if ($this.next().hasClass('current')) {
                $this.next().removeClass('current');
                $this.removeClass('selected');
                $this.next().slideUp(350);
            } else {
                $currentParentParent.find('li .inner').removeClass('current');
                $currentParentParent.find('.toggle').removeClass('selected');
                $currentParentParent.find('li .inner').slideUp(350);
                $this.next().toggleClass('current');
                $this.toggleClass('selected');

                $this.next().slideToggle(350, function() {
                    if ($('.selected').offset()) {
                        $('html,body').animate({
                            scrollTop: $('.selected').offset().top - 100
                        }, 500);
                    }
                });
            }
        });
    }
});

/*================ End Of Content-v1 template ================*/

$(document).ready(function() {
    const $form = $('.influencer-signup');

    (function($) {
        $.fn.serializeFormJSON = function() {
            const o = {};
            const a = this.serializeArray();
            $.each(a, function() {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });

            return o;
        };
    })(jQuery);

    function validateEmail(email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        }

        return false;
    }

    const isValidSubmission = function($data) {
        let valid = true;

        if ($data.email === '' || !validateEmail($data.email)) {
            valid = false;
            $('#js-email-error').removeClass('visually-hidden');
            $('.js-email').addClass('error');
        }

        if ($data.first === '' || $data.last === '') {
            valid = false;
            const $errorElement = $('#js-name-error');

            $errorElement.removeClass('visually-hidden');
            $('.js-name').addClass('error');

            const offset = $errorElement.offset();
            $('html, body').animate({
                scrollTop: offset.top - 200
            });
        }

        if (!$data.hasOwnProperty('platform')) {
            valid = false;
            const $errorElement = $('#js-platform-error');
            $errorElement.removeClass('visually-hidden');
        }

        if ($data.handle === '') {
            valid = false;
            $('#js-handle-error').removeClass('visually-hidden');
            $('.js-handle').addClass('error');
        }

        if ($data.why === '') {
            valid = false;
            $('#js-why-error').removeClass('visually-hidden');
            $('.js-why').addClass('error');
        }

        if (!$data.hasOwnProperty('terms')) {
            valid = false;
            $('#js-terms-error').removeClass('visually-hidden');
        }

        return valid;
    }
    
    if ($form.length > 0) {
        const apiUrl = $form.data().url;

        $('.js-name, .js-email, .js-platform, .js-handle, .js-why, .js-terms').change(function() {
            $('.js-name, .js-email, .js-platform, .js-handle, .js-why, .js-terms').removeClass('error');
            $('.form__error-text').addClass('visually-hidden');
        });

        $(document).on('click', '.js-submit-btn', function(e) {
            e.preventDefault();
            const $this = $(this);
            const $formData = $this.closest('form').serializeFormJSON();

            if (isValidSubmission($formData)) {
                $.ajax({
                    type: 'POST',
                    url: apiUrl,
                    data: JSON.stringify($formData),
                    cache: false,
                    contentType: 'application/json;',
                    error: function(error) {
                        $('#js-submit-error').removeClass('visually-hidden');
                    },
                    success: function(data) {
                        $('.form').addClass('visually-hidden')
                        $('.js-form-success').removeClass('visually-hidden');
                        $('html, body').animate({scrollTop: 0})
                    }
                });
            }
        });
    }
});

// =require modules/mobile-check.js
function toggleInputField() {
    const passwordField = document.getElementsByClassName('password-reveal__input')[0];
    const wrapper = document.getElementsByClassName('password-reveal-icon__wrapper')[0];
    const type = passwordField.type;

    if (type === 'password') {
        passwordField.setAttribute('type', 'text');
        wrapper.classList.add('hide-password');
    }

    if (type === 'text') {
        passwordField.setAttribute('type', 'password');
        wrapper.classList.remove('hide-password');
    }
}

function showPasswordListeners() {
    const toggleButton = document.getElementsByClassName('icon-password-reveal')[0];
    const passwordContainer = document.getElementsByClassName('password-reveal')[0];
    const passwordField = document.getElementsByClassName('password-reveal__input')[0];

    if (!toggleButton) {
        return;
    }
    if (!passwordContainer) {
        return;
    }
    if (!passwordField) {
        return;
    }

    toggleButton.addEventListener('click', function() {
        if (passwordField.value !== '') {
            toggleInputField();
            passwordContainer.style.borderColor = '#007DB5';
            if (this !== document.activeElement) {
                passwordField.focus();
            }
        }
    });

    passwordField.addEventListener('focus', function() {
        passwordContainer.style.borderColor = '#007DB5';
    });

    passwordField.addEventListener('blur', function() {
        passwordContainer.style.borderColor = '#eeeeee';
    });
}

function handleError(el, errorText) {
    const input = el;
    const errorId = input.classList.contains('birthday') ? 'for-birthday' : 'for-' + el.id;
    const errorSpan = document.getElementById(errorId);
    const errorMessage = errorText ? errorText : input.dataset.errorMessage;

    errorSpan.style.display = 'inline-block';
    errorSpan.innerHTML = errorMessage;
    input.style.borderColor = '#BF2E35';
}

function clearError(el) {
    const input = el;
    const errorId = input.classList.contains('birthday') ? 'for-birthday' : 'for-' + el.id;
    const errorSpan = document.getElementById(errorId);

    errorSpan.style.display = 'inline';
    errorSpan.innerHTML = '';
    input.style.borderColor = '#eeeeee';
}

function emailValidation(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

function birthdayValidation(id, num) {
    if (id === 'day') {
        return num >= 1 && num <= 31;
    }

    if (id === 'month') {
        return num >= 1 && num <= 12;
    }

    if (id === 'year') {
        const year = new Date().getFullYear();
        return num >= 1900 && num <= year;
    }
}

function dateValidation() {
    const birthdayInputs = document.getElementsByClassName('birthday');
    let validateDate = true;

    for (let i = 0; i < birthdayInputs.length; i += 1) {
        const el = birthdayInputs[i];

        if (el.value === '') {
            validateDate = false;
        }
    }

    if (validateDate) {
        const userYear = birthdayInputs[2].value;
        const userMonth = birthdayInputs[1].value;
        const userDate = birthdayInputs[0].value;
        const userDateString = userYear + '-' + userMonth + '-' + userDate;
        const userMoment = moment(userDateString, 'YYYY-MM-DD');

        if (!userMoment.isValid()) {
            handleError(birthdayInputs[2], birthdayInputs[2].dataset.dateValidation);

            return false;
        }

        if (moment().diff(userMoment, 'years') < 18) {
            handleError(birthdayInputs[2], birthdayInputs[2].dataset.dobValidation);

            return false;
        }

        clearError(birthdayInputs[2]);

        return true;
    }
}

function nameValidation(name) {
    return name.trim().length > 1 && /^([^0-9]*)$/.test(name);
}

function genderValidation(gender) {
    return gender;
}

function minimumCharactersCheck(password) {
    return password.length >= 8;
}

function uppercaseCheck(password) {
    return /.*[A-Z]+.*/.test(password);
}

function lowercaseCheck(password) {
    return /.*[a-z]+.*/.test(password);
}

function specialCharacterCheck(password) {
    return /.*[!@#$%^&*(),.?":{}|<>]+.*/.test(password);
}

function numberCheck(password) {
    return /.*[0-9]+.*/.test(password);
}

function passwordValidation(password) {
    return minimumCharactersCheck(password) &&
        uppercaseCheck(password) &&
        lowercaseCheck(password) &&
        specialCharacterCheck(password) &&
        numberCheck(password);
}

function handlePasswordError(password) {
    const container = document.getElementsByClassName('password-validation')[0];
    container.style.display = 'block';

    const input = document.getElementsByClassName('password-reveal')[0];
    input.style.borderColor = '#BF2E35';

    const errorSpan = document.getElementById('for-password');
    errorSpan.style.display = 'inline-block';

    const characters = document.getElementById('pw_characters');
    const uppercase = document.getElementById('pw_uppercase');
    const lowercase = document.getElementById('pw_lowercase');
    const special = document.getElementById('pw_special');
    const num = document.getElementById('pw_number');

    characters.style.opacity = minimumCharactersCheck(password) ? '1' : '0.3';
    uppercase.style.opacity = uppercaseCheck(password) ? '1' : '0.3';
    lowercase.style.opacity = lowercaseCheck(password) ? '1' : '0.3';
    special.style.opacity = specialCharacterCheck(password) ? '1' : '0.3';
    num.style.opacity = numberCheck(password) ? '1' : '0.3';
    errorSpan.style.color = passwordValidation(password) ? '#9b9b9b' : '#BF2E35';
    if (passwordValidation(password)) {
        input.style.borderColor = '#007DB5';
    }
}

function assignPwKeyUpListener(el) {
    el.addEventListener('keyup', function() {
        handlePasswordError(el.value);
    });
}

function clearPasswordError() {
    const container = document.getElementsByClassName('password-validation')[0];
    container.style.display = 'none';

    const inputContainer = document.getElementsByClassName('password-reveal')[0];
    inputContainer.style.borderColor = '#eeeeee';

    const errorSpan = document.getElementById('for-password');
    errorSpan.style.display = 'inline';
}

function loginPasswordError() {
    const input = document.getElementsByClassName('password-reveal')[0];
    input.style.borderColor = '#BF2E35';
}

function requiredCheck() {
    const elements = Array.from(document.querySelectorAll('.centered-form input')).concat(
        Array.from(document.querySelectorAll('.centered-form select'))
    );
    let complete = true;
    for (let i = 0; i < elements.length; i += 1) {
        const el = elements[i];
        if (!el.value) {
            complete = false;
        }
    }

    if (complete) {
        const alert = document.getElementsByClassName('alert')[0];
        alert.style.display = 'none';
    }
}

function validator(val, el) {
    requiredCheck();
    switch (el.id) {
        case 'email':
            if (!emailValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'day':
        case 'month':
        case 'year':
            if (!birthdayValidation(el.id, val)) {
                handleError(el);
                break;
            }
            clearError(el);
            dateValidation();
            break;
        case 'firstname':
        case 'lastname':
            if (!nameValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'gender':
            if (!genderValidation(val)) {
                handleError(el);
                break;
            }
            clearError(el);
            break;
        case 'password':
            if (!passwordValidation(val)) {
                handlePasswordError(val);
                assignPwKeyUpListener(el);
                break;
            }
            clearPasswordError();
        default:
            break;
    }
}

function createAccountListeners() {
    const toValidate = document.getElementsByClassName('toValidate');

    Array.prototype.forEach.call(toValidate, function(el) {
        let eventType;
        if (el.id === 'gender' || el.id === 'day' || el.id === 'month' || el.id === 'year') {
            eventType = 'change';
        } else {
            eventType = 'blur';
        }

        el.addEventListener(eventType, function(e) {
            validator(e.target.value, el);
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    showPasswordListeners();
    createAccountListeners();
});

const realm = window.theme.gsCode;

window.addEventListener('load', function () {
    const databaseConnection = 'Centralised-Login';

    const $pwResetForm = document.getElementsByClassName('js-reset-form')[0];
    const $loginForm = document.getElementsByClassName('js-login-form')[0];

    const $resetErrorMessage = document.getElementById('error-message-reset');
    const $resetSuccessMessage = document.getElementById(
        'success-message-reset'
    );

    const $loginBtn = document.getElementById('js-auth-login');
    const $logoutBtn = document.getElementsByClassName('js-auth-logout')[0];
    const $signupBtn = document.getElementById('js-auth-signup');
    const $pwResetBtn =
        document.getElementsByClassName('js-reset-pw-submit')[0];
    const $showPwResetBtn =
        document.getElementsByClassName('js-show-pw-reset')[0];

    let country;

    if (typeof GeoIPService === 'function') {
        const geoip = new GeoIPService();
        geoip.countryLookup();
        setTimeout(function () {
            country = geoip.getCountryIso();
        }, 1500);
    }

    function getUrlParams() {
        const params = {};
        window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                params[key] = value;
            }
        );

        return params;
    }

    function getAuthClient() {
        const params = getUrlParams();

        if (!authConfig.redirectUri.includes('?checkout=')) {
            if (params['checkout_url']) {
                authConfig.redirectUri =
                    authConfig.redirectUri +
                    '?checkout=' +
                    params['checkout_url'];
            }
        }

        return new auth0.WebAuth(authConfig);
    }

    function displayError(err) {
        const errorMessage = document.getElementById('error-message');
        const success = document.getElementById('signup-success');
        if (success) {
            success.style.display = 'none';
        }

        err = changeUserExistError(err);
        errorMessage.innerHTML = err.description;
        errorMessage.style.display = 'block';
    }

    function changeUserExistError(err) {
        if (err.code === 'user_exists') {
            err.description =
                '<p>The user already exists.</p>\
                               <p>If you have used our conditioning app you may already have an account and you can use those details to login.</p>';
        }
        return err;
    }

    function displayResetError(err) {
        $resetErrorMessage.innerHTML = err.description || err;
        $resetErrorMessage.style.display = 'block';
        $resetSuccessMessage.style.display = 'none';
    }

    function displaySuccess() {
        $resetSuccessMessage.innerHTML = window.theme.accountTranslations.passwordResetSuccess;
        $resetSuccessMessage.classList.add('transition-in');
        $resetErrorMessage.style.display = 'none';
    }

    function showResetForm(e) {
        e.preventDefault();
        $loginForm.classList.add('hide');
        $pwResetForm.classList.remove('hide');
    }

    function showLoginForm(e) {
        e.preventDefault();
        $loginForm.classList.remove('hide');
        $pwResetForm.classList.add('hide');
    }

    function login(e) {
        e.preventDefault();
        
        const pendingLoginClass = 'login--pending';
        const loginSpinner =
            document.getElementsByClassName('login-spinner')[0];
        const username = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        const emptyFields = checkEmpty(username, password);
        const webAuth = getAuthClient();
        const audience = $loginForm.dataset.audience;

        if (emptyFields.length === 0) {
            loginSpinner.classList.add(pendingLoginClass);
            $loginBtn.disabled = true;

            sessionStorage.setItem('session_signin_process', 'true');

            return webAuth.login(
                {
                    realm: realm,
                    username: username,
                    password: password,
                    scope: 'openid profile email',
                    audience: audience,
                },
                function (err) {
                    loginSpinner.classList.remove(pendingLoginClass);
                    $loginBtn.disabled = false;

                    if (err) {
                        sessionStorage.removeItem('session_signin_processed');
                        console.log(err);
                        displayError(err);
                    }
                }
            );
        }
    }

    function logout(e) {
        e.preventDefault();
        const webAuth = getAuthClient();

        if (window.mParticle) {
            window.mParticle.Identity.logout({});
        }

        webAuth.logout({
            returnTo: window.theme.domain + '/account/logout',
            clientID: authConfig.clientID,
        });
    }

    function checkEmpty() {
        const empty = [];
        const ids = [
            'email',
            'password',
            'firstname',
            'lastname',
            'gender',
            'day',
            'month',
            'year',
        ];
        for (let i = 0; i < arguments.length; i += 1) {
            if (!arguments[i]) {
                empty.push(ids[i]);
            }
        }
        return empty;
    }

    function formatDate(day, month, year) {
        const string = year + '-' + month + '-' + day;
        const date = moment.utc(string, 'YYYY-MM-DD');
        return date.unix() * 1000;
    }

    function signup() {
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        const firstname = document.getElementById('firstname').value;
        const lastname = document.getElementById('lastname').value;

        const genderElement = document.getElementById('gender');
        const gender = genderElement.options[genderElement.selectedIndex].value;

        const dayElement = document.getElementById('day');
        const day = dayElement.options[dayElement.selectedIndex].value;

        const monthElement = document.getElementById('month');
        const month = monthElement.options[monthElement.selectedIndex].value;

        const yearElement = document.getElementById('year');
        const year = yearElement.options[yearElement.selectedIndex].value;

        const $emailCheck = document.querySelector('#email_optin:checked');

        const emailOptin =
            typeof $emailCheck !== 'undefined' && $emailCheck !== null
                ? $emailCheck.value
                : false;
        const now = new Date().getTime();
        const acceptsMarketingUpdatedAt = emailOptin ? now.toString() : '';

        const timeStamp = formatDate(day, month, year);
        const emptyFields = checkEmpty(
            email,
            password,
            firstname,
            lastname,
            gender,
            day,
            month,
            year
        );

        if (emptyFields.length === 0) {
            if (!dateValidation()) {
                return;
            }

            const customer = {
                realm: realm,
                connection: databaseConnection,
                email: email,
                password: password,
                given_name: firstname,
                family_name: lastname,
                name: firstname + ' ' + lastname,
                userMetadata: {
                    realm: realm,
                    gender: gender.toString(),
                    names: JSON.stringify({
                        given_name: firstname,
                        family_name: lastname,
                    }),
                    acceptsMarketing: emailOptin.toString(),
                    acceptsMarketingUpdatedAt: acceptsMarketingUpdatedAt,
                    dob: timeStamp.toString(),
                    country: country,
                },
            };

            const webAuth = getAuthClient();

            return webAuth.signup(customer, function (err) {
                if (err) {
                    return displayError(err);
                }

                const params = getUrlParams();

                if (params['checkout_url']) {
                    return (window.location.href = `/account/login?signupSuccess=true&checkout_url=${params['checkout_url']}`);
                }

                window.location.href = '/account/login?signupSuccess=true';
            });
        }

        Array.prototype.forEach.call(emptyFields, function (id) {
            const el = document.getElementById(id);
            const val = el.value;
            validator(val, el);
        });

        return displayError({ description: 'Please fill out all the fields' });
    }

    function resetPassword() {
        const email = document.getElementById('reset-email').value;

        let payload = {
            client_id: authConfig.clientID,
            email: email,
            connection: 'Centralised-Login',
        };

        fetch(
            'https://' + authConfig.domain + '/dbconnections/change_password',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            }
        )
            .then(function (response) {
                if (!response.ok && response.status !== 200) {
                    return response.json();
                }
                return response.text();
            })
            .then(function (body) {
                if (typeof body === 'object') {
                    throw new Error(body.error || body.message);
                } else {
                    displaySuccess(body);
                    const button =
                        document.getElementsByClassName(
                            'js-reset-pw-submit'
                        )[0];

                    button.disabled = true;
                }
            })
            .catch(function (error) {
                displayResetError(error);
            });
    }

    if (getUrlParams().signupSuccess) {
        document
            .getElementById('success-message')
            .classList.add('transition-in');
    }

    if ($loginForm) {
        $loginForm.style.display = 'block';
    }

    const $showLoginBtn = document.getElementsByClassName('js-show-login')[0];

    if (typeof $loginBtn !== 'undefined' && $loginBtn !== null) {
        $loginBtn.addEventListener('click', login);
    }

    if (typeof $logoutBtn !== 'undefined' && $logoutBtn !== null) {
        $logoutBtn.addEventListener('click', logout);
    }

    if (typeof $signupBtn !== 'undefined' && $signupBtn !== null) {
        $signupBtn.addEventListener('click', signup);
    }

    if (typeof $pwResetBtn !== 'undefined' && $pwResetBtn !== null) {
        $pwResetBtn.addEventListener('click', resetPassword);
    }

    if (typeof $showPwResetBtn !== 'undefined' && $showPwResetBtn !== null) {
        $showPwResetBtn.addEventListener('click', showResetForm);
    }

    if (typeof $showLoginBtn !== 'undefined' && $showLoginBtn !== null) {
        $showLoginBtn.addEventListener('click', showLoginForm);
    }
});

/* =======================================================
APP FAQ Page
======================================================== */
document.addEventListener('DOMContentLoaded', function() {
    const appFaqPage = document.getElementsByClassName('app-faq__container');

    if (appFaqPage.length) {
        function setAppFAQPage() {
            const appFaqToggle = document.getElementsByClassName('app-faq__accordion-toggle');
            const appFaqToggleLength = appFaqToggle.length;
            const accordionToggleSelected = 'app-faq__accordion-toggle-selected';
            const accordionInnerShow = 'app-faq__accordion-inner-show';

            function hideAppFaqData() {
                for (let i = 0; i < appFaqToggleLength; i += 1) {
                    appFaqToggle[i].classList.remove(accordionToggleSelected);
                    appFaqToggle[i].nextElementSibling.classList.remove(accordionInnerShow);
                }
            };

            function showAppFaqData(currentFaqSelected, currentFaqSelectedInsideData) {
                currentFaqSelected.classList.toggle(accordionToggleSelected);
                currentFaqSelectedInsideData.classList.toggle(accordionInnerShow);

                if (currentFaqSelected.classList.contains(accordionToggleSelected)) {
                    const faqSelected = currentFaqSelected.offsetTop - 100;

                    window.scroll({
                        top: faqSelected,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            };

            function onAppFaqToggleClicked(e) {
                const currentFaqSelected = e.currentTarget;
                const currentFaqSelectedInsideData = currentFaqSelected.nextElementSibling;

                if (!currentFaqSelectedInsideData.classList.contains(accordionInnerShow)) {
                    hideAppFaqData();
                }

                showAppFaqData(currentFaqSelected, currentFaqSelectedInsideData);
            };

            function addMouseEventOnFaqQuestions() {
                for (let i = 0; i < appFaqToggleLength; i += 1) {
                    appFaqToggle[i].addEventListener('click', function(e) {
                        e.preventDefault();
                        onAppFaqToggleClicked(e);
                    });
                }
            };

            addMouseEventOnFaqQuestions();
        };

        setAppFAQPage();
    }
});

function validateAge(age, usersBirthDay, usersBirthMonth, usersBirthYear) {
    const ageValidation = age;
    const todaysDate = new Date();
    const usersBirthDate = new Date();

    todaysDate.setFullYear(todaysDate.getFullYear() - ageValidation);
    usersBirthDate.setFullYear(usersBirthYear, usersBirthMonth - 1, usersBirthDay);

    return (todaysDate >= usersBirthDate);
}

document.addEventListener('DOMContentLoaded', function() {
    const multiClass = 'multi-image-block';
    const discountClass = 'discount-block';
    const multiImageBlocks = document.getElementsByClassName(multiClass);
    const discountBlock = document.getElementsByClassName(discountClass);

    if (multiImageBlocks && multiImageBlocks.length > 1) {
        for (let i = 0; i < multiImageBlocks.length; i += 1) {
            const el = multiImageBlocks[i];
            const nextEl = el.parentNode.nextSibling;

            if (nextEl && nextEl.children && nextEl.children[0] && nextEl.children[0].classList.contains(multiClass)) {
                el.classList.add('decrease-margin');
            }
        }
    }

    if (discountBlock && discountBlock.length > 0) {
        for (let i = 0; i < discountBlock.length; i += 1) {
            const el = discountBlock[i];
            const prevEl = el.previousSibling;

            if (prevEl && prevEl.children && prevEl.children[0] && prevEl.children[0].classList.contains(multiClass) || prevEl.classList.contains('collection_index')) {
                el.classList.add('remove-margin-top');
            }
        }
    }
});


if (!('ontouchstart' in document.documentElement)) {
    document.documentElement.className += ' no-touch';
}

$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper'
    });

    // Target iframes to make them responsive
    var iframeSelectors =
        '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace(
            'supports-no-cookies',
            'supports-cookies'
        );
    }

    $(document).on('click', '.mobile-localisation a', function(e) {
        e.preventDefault();
        var $this = $(this);

        $.cookie('countryRedirectGS', $this.attr('href'), {
            domain: '.gymshark.com',
            expires: 90,
            path: '/'
        });
        window.location = $this.attr('href') + window.location.pathname + window.location.search;
    });

    // Mobile Filters Display Fix
    $('#mobile--filters').addClass('display-fix');

    function setViewportVariable() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    };

    setViewportVariable();
});

